
export default () => {

	// Open Menu
	const navTrigger = document.querySelector(".js-open-nav");
	const projectWrapper = document.getElementById("app");
	const drawer = document.querySelector(".drawer");

	// Toggle Menu
	bindEvent(navTrigger, "click", () => {
	    navTrigger.classList.toggle("is-active");
	    projectWrapper.classList.toggle("js-is-open");
	    drawer.classList.toggle("js-is-open");
	});

	// Bind event
	function bindEvent(el, eventName, eventHandler) {
	    if (el.addEventListener) {
	      el.addEventListener(eventName, eventHandler, false);
	    } else if (el.attachEvent) {
	      el.attachEvent(`on${  eventName}`, eventHandler);
	    }
	}

	// Mobile navigation (global)
    var nav = document.querySelector('[data-nav]');
    var navTriggerMobile = document.querySelector('[data-nav-trigger]');

    if(navTriggerMobile){
        navTriggerMobile.addEventListener('click', function() {
            navTriggerMobile.classList.toggle('is-active');
            nav.classList.add('drawer--transition');
            nav.classList.toggle('drawer--active');
            document.body.classList.toggle('drawer-active');
        });
    }
}